(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["language-switcher"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__casifyLangInit) return;
    window.__casifyLangInit = true;

    function setOpen(el, isOpen) {
      el.classList.toggle('is-open', isOpen);
      el.querySelector('.casify-lang__toggle').setAttribute('aria-expanded', String(isOpen));
      if (el.classList.contains('casify-lang--mobile-menu')) {
        var panel = el.querySelector('.casify-lang__panel');
        panel.toggleAttribute('inert', !isOpen);
        panel.setAttribute('aria-hidden', String(!isOpen));
      }
    }

    function closeAll(except) {
      document.querySelectorAll('.casify-lang.is-open').forEach(function (el) {
        if (el === except) return;
        setOpen(el, false);
      });
    }

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('.casify-lang__toggle');
      if (toggle) {
        var wrap = toggle.closest('.casify-lang');
        var willOpen = !wrap.classList.contains('is-open');
        closeAll(wrap);
        setOpen(wrap, willOpen);
        e.stopPropagation();
        return;
      }
      if (!e.target.closest('.casify-lang__panel')) closeAll(null);
    });

    // Capture before the sidebar's Escape handler: first close the disclosure,
    // then let a second Escape close the whole menu, irrespective of script order.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var mobileLanguage = document.querySelector('.mobile-sidebar--open .casify-lang--mobile-menu.is-open');
      if (!mobileLanguage) return;
      e.preventDefault();
      e.stopPropagation();
      setOpen(mobileLanguage, false);
      mobileLanguage.querySelector('.casify-lang__toggle').focus();
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
